// material-ui
import { styled } from '@mui/material/styles';
import { Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';

// styles
const CardStyle = styled(Card)(() => ({
    background: '#00214D',
    marginTop: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
    position: 'relative',
    color: 'white'
    // '&:after': {
    //     content: '""',
    //     position: 'absolute',
    //     width: '200px',
    //     height: '200px',
    //     border: '19px solid ',
    //     borderColor: '#FCB413',
    //     borderRadius: '50%',
    //     top: '65px',
    //     right: '-150px'
    // },
    // '&:before': {
    //     content: '""',
    //     position: 'absolute',
    //     width: '200px',
    //     height: '200px',
    //     border: '3px solid ',
    //     borderColor: '#FCB413',
    //     borderRadius: '50%',
    //     top: '145px',
    //     right: '-70px'
    // }
}));
import { SET_MODAL_TYPE, SET_MODAL_STATUS, SET_TOAST_OBJECT } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
// import axios from 'utils/axios';
// import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import { useState } from 'react';
// import { diffDayAndTime } from '@fullcalendar/react';

const UpgradePlanCard = () => {
    const token = localStorage.getItem('diologAuthToken') || '';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const { companyData, userData } = useSelector((params) => params.customization);
    //const [planList, setPlansList] = useState([]);
    var date2 = new Date(companyData?.subscription?.endDate);
    var date1 = new Date();
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

    // useEffect(() => {
    //     axios({
    //         method: 'GET',
    //         url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/products/v2',
    //         headers: { Authorization: `${token}` }
    //     }).then(function (response) {
    //         setPlansList(response.data.data);
    //     });
    // }, []);

    const handleClick = (isReactivate) => {
        if (!companyData?.subscription?.plan) return;
        setDisabled(false);
        let type = isReactivate ? 'Yes' : 'No';
        navigate('/dashboard/update-plan/?isReactivate=' + type);
        return;
    };

    // const setDispatchErrorMessage = (message, variant) => {
    //     dispatch({
    //         type: SET_TOAST_OBJECT,
    //         toastObject: {
    //             variant: variant,
    //             message: message,
    //             status: true
    //         }
    //     });
    // };

    // const callApi = async (body) => {
    //     try {
    //         setLoading(true);

    //         const response = await axios({
    //             method: 'POST',
    //             url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/subscribe/v2',
    //             data: body,
    //             headers: { Authorization: `${token}` }
    //         });
    //         return response;
    //     } catch (e) {
    //         // setDispatchErrorMessage(e?.response?.data?.message || e.message || 'Sorry something error occcured.', 'error');
    //         throw e;
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const actionAfterPostingPlanSelection = (type, response) => {
    //     if (type === PLAN_TYPE.Premium) window.location.href = response?.data?.url || '';
    // };

    // const onUpdatePlan = async () => {
    //     const planItem = planList.find((plan) => plan.name === companyData?.subscription?.plan);
    //     if (!planItem) {
    //         setDispatchErrorMessage('No plan id was provided', 'error');
    //         return;
    //     }
    //     try {
    //         let body = {
    //             type: companyData?.subscription?.plan,
    //             priceId: planItem.default_price,
    //             flag: true,
    //             range: companyData?.subscription?.quantity,
    //             isReactivate: true
    //         };
    //         const response = await callApi(body);
    //         actionAfterPostingPlanSelection(body.type, response);
    //     } catch (e) {
    //         setDispatchErrorMessage(e?.response?.data?.message || e.message || 'Sorry something error occcured.', 'error');
    //     }
    // };
    return (
        <CardStyle sx={{ p: 0, m: 0 }} className="upgrade-card">
            {!companyData?.subscription?.hold || companyData?.subscription?.plan === PLAN_TYPE.Freemium ? (
                <CardContent>
                    <Grid container direction="column" rowSpacing={1.5}>
                        {companyData && companyData?.subscription?.plan === PLAN_TYPE.Freemium && (
                            <Grid item sx={{ width: '230px' }}>
                                <Typography variant="h4" component="h4" sx={{ mb: 1 }}>
                                    Activate your Premium plan.
                                </Typography>
                                <Typography variant="p" component="p">
                                    To gain all features on this platform please subscribe to Premium plan.
                                </Typography>
                            </Grid>
                        )}
                        {companyData && companyData?.subscription?.status !== 'inactive' && (
                            <>
                                {Difference_In_Days > 0 ? (
                                    <>
                                        <Grid item>
                                            <Typography variant="p" component="p">
                                                Current plan
                                            </Typography>
                                            <Typography variant="h4" color="white">
                                                {companyData?.subscription?.plan}
                                            </Typography>
                                        </Grid>
                                        {companyData?.subscription?.plan === PLAN_TYPE.Premium && (
                                            <Grid item>
                                                <Typography variant="p" component="p">
                                                    Remaining days : {companyData?.subscription?.endDate ? Difference_In_Days : '-'} days
                                                    {companyData?.subscription?.status == 'trialing' ? ' (Trial)' : ''}
                                                </Typography>
                                                <Typography variant="p" component="p">
                                                    Renewal date :
                                                    {companyData?.subscription?.endDate
                                                        ? ' ' + format(new Date(companyData?.subscription?.endDate), 'dd LLL, yyyy')
                                                        : ''}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </>
                                ) : (
                                    <Grid item sx={{ width: '230px' }}>
                                        <Typography variant="h4" component="h4" sx={{ mb: 1 }}>
                                            Your subscription has expired.
                                        </Typography>
                                        <Typography variant="p" component="p">
                                            To regain your access, please renew your subscription now.
                                        </Typography>
                                    </Grid>
                                )}
                            </>
                        )}
                        <Grid item>
                            <Stack direction="column">
                                {userData?.stripeCustomerId &&
                                    !companyData?.subscription?.renewable &&
                                    !companyData?.subscription?.status == 'trialing' && (
                                        <AnimateButton>
                                            <Button
                                                variant="filled"
                                                className="medium filled secondary alt mb-1"
                                                onClick={() => {
                                                    dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                                    dispatch({ type: SET_MODAL_TYPE, modalType: 'plans' });
                                                }}
                                            >
                                                View plans
                                            </Button>
                                        </AnimateButton>
                                    )}
                                <AnimateButton>
                                    {userData?.stripeCustomerId ? (
                                        <Button
                                            variant="filled"
                                            className="medium filled secondary alt"
                                            onClick={() => handleClick(false)}
                                            disabled={disabled}
                                        >
                                            {disabled
                                                ? 'Loading...'
                                                : companyData.subscription?.plan === PLAN_TYPE.Freemium
                                                ? 'Upgrade'
                                                : 'View Plans'}
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="filled"
                                            className="medium filled secondary alt"
                                            onClick={() => {
                                                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                                dispatch({ type: SET_MODAL_TYPE, modalType: 'plans' });
                                            }}
                                        >
                                            View plans
                                        </Button>
                                    )}
                                </AnimateButton>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            ) : (
                <CardContent>
                    <Grid container direction="column" rowSpacing={1.5}>
                        {Difference_In_Days < 0 && (
                            <>
                                <Grid item sx={{ width: '230px' }}>
                                    <Typography variant="h4" component="h4" sx={{ mb: 1 }}>
                                        Your subscription has expired.
                                    </Typography>
                                    <Typography variant="p" component="p">
                                        To regain your access, please renew your subscription now.
                                    </Typography>
                                </Grid>

                                {userData?.stripeCustomerId && (
                                    <Grid item>
                                        <Button
                                            variant="filled"
                                            className="medium filled secondary alt"
                                            onClick={() => handleClick(false)}
                                            disabled={disabled}
                                        >
                                            {disabled ? 'Loading...' : 'View Plans'}
                                        </Button>
                                    </Grid>
                                )}
                            </>
                        )}

                        {Difference_In_Days > 0 && (
                            <>
                                <Grid item>
                                    <Typography variant="h4" component="h4" sx={{ mb: 1, color: '#F9B414 !important;' }}>
                                        {Difference_In_Days} days left of your Premium
                                        {companyData?.subscription?.status == 'trialing' ? ' (Trial)' : ''}.
                                    </Typography>
                                </Grid>
                                <Grid item sx={{ width: '230px' }}>
                                    <Typography variant="h4" component="h4" sx={{ mb: 1 }}>
                                        Change your mind?
                                    </Typography>
                                    <Typography variant="p" component="p">
                                        Keep enjoying all features by reactivating your Premium plan.
                                    </Typography>
                                </Grid>

                                <Grid item>
                                    <Typography variant="p" component="p">
                                        Current plan
                                    </Typography>
                                    <Typography variant="h4" color="white">
                                        {companyData?.subscription?.plan}
                                    </Typography>
                                </Grid>
                                <Grid item sx={{ placeSelf: 'center' }}>
                                    <Button
                                        variant="filled"
                                        className="medium filled secondary alt"
                                        onClick={() => handleClick(true)}
                                        disabled={loading}
                                    >
                                        Re-activate
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </CardContent>
            )}
        </CardStyle>
    );
};

export default UpgradePlanCard;
